import { GridStateMap } from '@app-store/reducers/grid.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectGridsState = createFeatureSelector<GridStateMap>('grids');

export const selectGridState = (props: {key: string}) =>
	createSelector(selectGridsState, (state: GridStateMap) => state.get(props.key));
